import styled from 'styled-components';

import NavMenuItem from '../NavMenuItem';

export const Collapse = styled.ul`
  display: none;
  margin-left: ${({ theme }) => theme.spacings.abs32}px;
`;

type MainNavMenuItemTransientProps = {
  $disableLabelUnderline: boolean;
};

export const MainNavMenuItem = styled(
  NavMenuItem,
)<MainNavMenuItemTransientProps>`
  &[aria-current] {
    & > .chevron-down-icon {
      transform: rotate(180deg);
    }
    & .label:before {
      display: ${(props) => (props.$disableLabelUnderline ? 'none' : 'block')};
    }
    &:before {
      display: none;
    }
    & + ul {
      display: block;
    }
  }
`;
